const divEquipServCard = {
  service: 'Service',
  label: 'Inspected by:',
  place: 'Place',
  company: 'Company',
};

export default divEquipServCard;
